var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-dialog',{attrs:{"value":_vm.open},on:{"hide":_vm.closeDialog}},[_c('q-card',{staticStyle:{"min-width":"600px"}},[_c('q-card-section',{staticClass:"text-h6"},[_vm._v(" Preview ")]),_c('q-card-section',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data ? _vm.data.htmlBody : '')}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }